import React from 'react';

export default function TimeIcon() {
  return (
    <svg
      id="time-icon"
      x="0px"
      y="0px"
      viewBox="0 0 20.8 20.8"
      width="24"
      height="24"
    >
      <path
        className="cls-1"
        d="M10.4,3a.4.4,0,0,0-.4.4v7a.4.4,0,0,0,.8,0v-7A.4.4,0,0,0,10.4,3Z"
      />
      <path
        className="cls-1"
        d="M17.77,17.72a10.36,10.36,0,0,0,0-14.64s0,0,0,0l0,0A10.37,10.37,0,0,0,3.07,3l0,0,0,0A10.37,10.37,0,0,0,3,17.72s0,0,0,0,0,0,0,0a10.36,10.36,0,0,0,14.64,0s0,0,0,0S17.77,17.73,17.77,17.72Zm-.72-1.24a.4.4,0,0,0-.57.57l.41.4A9.58,9.58,0,0,1,10.8,20V19.4a.4.4,0,0,0-.8,0V20a9.58,9.58,0,0,1-6.09-2.53l.41-.4a.4.4,0,0,0-.57-.57l-.4.41A9.58,9.58,0,0,1,.82,10.8H1.4a.4.4,0,0,0,0-.8H.82A9.58,9.58,0,0,1,3.35,3.91l.4.41A.4.4,0,0,0,4,4.44a.41.41,0,0,0,.28-.69l-.41-.4A9.58,9.58,0,0,1,10,.82V1.4a.4.4,0,0,0,.8,0V.82a9.58,9.58,0,0,1,6.09,2.53l-.41.4a.4.4,0,1,0,.57.57l.4-.41A9.58,9.58,0,0,1,20,10H19.4a.4.4,0,1,0,0,.8H20a9.58,9.58,0,0,1-2.53,6.09Z"
      />
      <path
        className="cls-1"
        d="M8.7,11.53,5.17,15.07a.39.39,0,0,0,0,.56.39.39,0,0,0,.56,0L9.27,12.1a.4.4,0,0,0-.57-.57Z"
      />
    </svg>
  );
}
